var map = {
	"./arrizo8/slider/slider-1.png": 7131,
	"./arrizo8/slider/slider-2.png": 8800,
	"./arrizo8/slider/slider-3.png": 3273,
	"./arrizo8/slider/slider-4.png": 3190,
	"./tenet4l/slider/slide-1.webp": 4977,
	"./tenet4l/slider/slide-2.webp": 8260,
	"./tenet4l/slider/slide-3.webp": 9271,
	"./tenet4l/slider/slide-4.webp": 8074,
	"./tenet4l/slider/slide-5.webp": 2245,
	"./tenet4l/slider/slide-6.webp": 2072,
	"./tenet7/slider/slide-1.webp": 8312,
	"./tenet7/slider/slide-2.webp": 4421,
	"./tenet7/slider/slide-3.webp": 3802,
	"./tenet7/slider/slide-4.webp": 5335,
	"./tenet7/slider/slide-5.webp": 2740,
	"./tenet7/slider/slide-6.webp": 225,
	"./tenet8/slider/slide-1.webp": 5363,
	"./tenet8/slider/slide-2.webp": 7938,
	"./tenet8/slider/slide-3.webp": 957,
	"./tenet8/slider/slide-4.webp": 1740,
	"./tenet8/slider/slide-5.webp": 3279,
	"./tenet8/slider/slide-6.webp": 6126,
	"./tenet8/slider/slide-7.webp": 665,
	"./tiggo4new/slider/slide-1.jpg": 802,
	"./tiggo4new/slider/slide-2.jpg": 701,
	"./tiggo4new/slider/slide-3.jpg": 9568,
	"./tiggo4new/slider/slide-4.jpg": 2403,
	"./tiggo4new/slider/slide-5.jpg": 5942,
	"./tiggo4pro/slider/slider-1.png": 5953,
	"./tiggo4pro/slider/slider-2.png": 8522,
	"./tiggo4pro/slider/slider-3.png": 435,
	"./tiggo4pro/slider/slider-4.png": 3036,
	"./tiggo7/slider/slider-1.png": 8525,
	"./tiggo7/slider/slider-2.png": 7846,
	"./tiggo7/slider/slider-3.png": 5935,
	"./tiggo7/slider/slider-4.png": 7280,
	"./tiggo7pro/slider/slider-1.png": 6660,
	"./tiggo7pro/slider/slider-2.png": 8287,
	"./tiggo7pro/slider/slider-3.png": 4486,
	"./tiggo7pro/slider/slider-4.png": 4457,
	"./tiggo7promax/slider/slider-1.png": 3052,
	"./tiggo7promax/slider/slider-2.png": 3735,
	"./tiggo7promax/slider/slider-3.png": 7950,
	"./tiggo7promax/slider/slider-4.png": 2513,
	"./tiggo7proplugin/slider/slider-1.png": 9245,
	"./tiggo7proplugin/slider/slider-2.png": 8038,
	"./tiggo7proplugin/slider/slider-3.png": 3231,
	"./tiggo7proplugin/slider/slider-4.png": 4208,
	"./tiggo8/slider/slider-1.png": 8406,
	"./tiggo8/slider/slider-2.png": 29,
	"./tiggo8/slider/slider-3.png": 3732,
	"./tiggo8/slider/slider-4.png": 5387,
	"./tiggo8pro/slider/slider-1.png": 933,
	"./tiggo8pro/slider/slider-2.png": 3582,
	"./tiggo8pro/slider/slider-3.png": 1895,
	"./tiggo8pro/slider/slider-4.png": 376,
	"./tiggo8promax/slider/slider-1.png": 6403,
	"./tiggo8promax/slider/slider-2.png": 4440,
	"./tiggo8promax/slider/slider-3.png": 1921,
	"./tiggo8promax/slider/slider-4.png": 7086,
	"./tiggo8proplugin/slider/slider-1.png": 7988,
	"./tiggo8proplugin/slider/slider-2.png": 6799,
	"./tiggo8proplugin/slider/slider-3.png": 1702,
	"./tiggo8proplugin/slider/slider-4.png": 329,
	"./tiggo9/slider/slide-1.jpg": 7769,
	"./tiggo9/slider/slide-10.jpg": 7829,
	"./tiggo9/slider/slide-11.jpg": 6648,
	"./tiggo9/slider/slide-12.jpg": 9495,
	"./tiggo9/slider/slide-13.jpg": 7338,
	"./tiggo9/slider/slide-2.jpg": 6270,
	"./tiggo9/slider/slide-3.jpg": 6427,
	"./tiggo9/slider/slide-4.jpg": 1544,
	"./tiggo9/slider/slide-5.jpg": 9157,
	"./tiggo9/slider/slide-6.jpg": 1930,
	"./tiggo9/slider/slide-7.jpg": 3863,
	"./tiggo9/slider/slide-8.jpg": 8708,
	"./tiggo9/slider/slide-9.jpg": 8657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3247;